import {Pipe, PipeTransform} from '@angular/core';
import {NotificationDto} from '../../Models/Notification/notification.interface';

@Pipe({
  name: 'notifications',
  standalone: false
})
export class NotificationsPipe implements PipeTransform {

  transform(items: NotificationDto[], filter: { groupId?: number, unseen?: boolean }): NotificationDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.groupId) {
      items = items.filter((item) => item.id_grupo === filter.groupId);
    }

    if (filter.unseen) {
      items = items.filter((item) => !item.vista);
    }

    return items;

  }

}
